import React from 'react';

// Fallback rendered by the app-level ErrorBoundary when a render-time error
// would otherwise unmount the whole React tree (React 19 blanks the root on
// uncaught errors → white webview). Gives the user a way back instead of a
// dead white screen; the boundary logs the underlying exception to the console.
export default function ErrorFallback({ resetError }) {
	return (
		<div className="fixed top-0 left-0 right-0 bottom-0 bg-white z-50 flex flex-col justify-center items-center px-6 text-center">
			<div className="text-[#1A1A1A] text-xl font-bold mb-2">कुछ गड़बड़ हो गई</div>
			<div className="text-[#666] text-sm mb-6">
				कृपया दोबारा कोशिश करें। अगर समस्या बनी रहे तो थोड़ी देर बाद फिर से खोलें।
			</div>
			<button
				type="button"
				onClick={() => {
					// resetError re-mounts the boundary's children; if the error
					// recurs immediately, fall back to a full reload.
					try {
						resetError?.();
					} catch {
						window.location.reload();
					}
				}}
				className="bg-[#D4472C] text-white font-bold h-11 px-10 rounded-2xl text-lg"
			>
				दोबारा कोशिश करें
			</button>
		</div>
	);
}
